import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import { createUserServiceValidationForm } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";
import ComboboxInput from "../Reusable/ComboboxInput";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import TextField from "../Reusable/TextInput";

const CreateUser = ({ handleCreate, isLoading }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    setValue,
    setError,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createUserServiceValidationForm),
  });
  return (
    <form onSubmit={handleSubmit((data) => handleCreate(data, setError))}>
      <div className={tw`grid md:grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Username"}
          register={register("username")}
          errors={errors?.username}
        />
        <TextField
          label={"Full Name"}
          register={register("full_name")}
          errors={errors?.full_name}
        />
        <TextField
          label={"Email"}
          register={register("email")}
          errors={errors?.email}
        />
        <ComboboxInput
          url={APIS.BRANCH}
          queryKey={"branch"}
          register={register("branch")}
          errors={errors?.branch}
          name={"branch"}
          label={"Branch"}
          props={{
            is_active: true,
          }}
          setValue={setValue}
          placeholder={"Select Branch"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <PhoneNumberField
          control={control}
          label={"Mobile Number"}
          name={"mobile_number"}
          errors={errors?.mobile_number}
        />

        <TextField
          label={"Address"}
          register={register("address_name")}
          errors={errors?.address_name}
        />
      </div>
      <div className={tw`w-full px-4 `}>
        <div className={tw`w-24 ml-auto`}>
          <Button label="Create" isLoading={isLoading} />
        </div>
      </div>
    </form>
  );
};

export default CreateUser;
